import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { getPortfolioOverview, type PortfolioOverview } from '@/lib/api/endpoints/portfolio'

export function usePortfolioOverview(
  quarter?: string,
  enabled = true,
): UseQueryResult<PortfolioOverview> {
  return useQuery({
    queryKey: ['portfolio', 'overview', quarter ?? null],
    queryFn: () => getPortfolioOverview(quarter === undefined ? {} : { quarter }),

    enabled,
    staleTime: 30_000,
  })
}
